const tags_values = {
    'OPTOUT_LANDING_PAGE' : 'Optout - Landingsida',
    'OPTOUT_CONFIRMATION' : 'Optout - Bekräftelse',
    'REDIRECT' : 'Redirect', 
}

export default tags_values 